import { IMAGE_SRC_TYPES } from "@/config/image";
import pictureSizeUrlParams from "@/config/pictureSizeUrlParams";

/**
 *
 * @param {String} url
 * @param {String} number
 * @param {String} type
 * @param {String} size
 *
 * @returns {String}
 */
export default function getPictureUrl(url, number, type = IMAGE_SRC_TYPES.IMAGE, size) {
  let result = type === IMAGE_SRC_TYPES.YOUTUBE
    ? process.env.VUE_APP_YOUTUBE_PREVIEW_URL
    : url

  if (type === IMAGE_SRC_TYPES.YOUTUBE) {
    const youtubeCodes = (number || '').split('/');
    const youtubeCode = youtubeCodes[youtubeCodes.length - 1];
    result += youtubeCode;
  }

  try {
    result += pictureSizeUrlParams[type][size] || ''
  } catch (e) {
    console.log(e, type, size, number, url)
  }

  return result
}
